import { useEffect } from "react";

const sections = [
  {
    id: "acceptance",
    title: "1. Acceptance of Terms",
    body: "By using the Aardvarks Vault website or submitting a collection for an offer, you agree to these Terms of Service. If you do not agree, please do not use the site. Aardvarks Vault is a Texas-based online collectibles business serving sellers nationwide.",
  },
  {
    id: "offers",
    title: "2. Offers & Evaluations",
    body: "Submitting the seller form is a request for an offer, not a contract of sale. Any offer we make is based on the information and photos you provide, is free and without obligation, and may be revised after in-hand inspection if a collection materially differs from its description. A sale is final only when both parties confirm acceptance in writing.",
  },
  {
    id: "accuracy",
    title: "3. Accuracy of Submissions",
    body: "You represent that you own the items you offer to sell, that they are authentic and lawfully obtained, and that the information you provide (condition, contents, size, value) is accurate to the best of your knowledge. Counterfeit or stolen property will not be purchased and may be reported to authorities.",
  },
  {
    id: "shipping",
    title: "4. Shipping & Insurance",
    body: "For accepted offers, we provide prepaid shipping labels insured up to the agreed offer value when packed according to our packing guide. Risk of loss transfers per the carrier's terms; claims for shipments not packed per the guide may be limited by the carrier.",
  },
  {
    id: "payment",
    title: "5. Payment",
    body: "Payment is typically issued within 24 hours after your collection is received and verified, using the payout method agreed at acceptance. Verification includes confirming contents, authenticity, and condition against your submission.",
  },
  {
    id: "uploads",
    title: "6. Uploaded Content",
    body: "By uploading photos or card lists, you grant Aardvarks Vault a limited license to store and review them solely for evaluating your collection. You retain all ownership of your content. Do not upload anything you do not have the right to share.",
  },
  {
    id: "marketplace",
    title: "7. Marketplace & Social Content",
    body: "Inventory shown on our website, marketplace pages, or social channels is subject to prior sale and availability. Prices and descriptions on third-party storefronts (when launched) are governed by those platforms' terms in addition to ours.",
  },
  {
    id: "liability",
    title: "8. Limitation of Liability",
    body: "To the fullest extent permitted by law, Aardvarks Vault is not liable for indirect, incidental, or consequential damages arising from use of the website. Our total liability relating to any transaction is limited to the agreed purchase price of the items involved.",
  },
  {
    id: "law",
    title: "9. Governing Law",
    body: "These terms are governed by the laws of the State of Texas, without regard to conflict-of-law principles. Any disputes will be resolved in the courts located in Texas.",
  },
  {
    id: "contact",
    title: "10. Contact & Changes",
    body: "We may update these terms from time to time; the current version is always posted here. Questions about these terms can be sent to ashton@aardvarksvault.com.",
  },
];

const Terms = () => {
  useEffect(() => {
    document.title = "Terms of Service — Aardvarks Vault";
  }, []);

  return (
    <div className="px-5 pb-24 pt-40 sm:px-8" data-testid="terms-page">
      <div className="mx-auto max-w-3xl">
        <p className="eyebrow">Legal</p>
        <h1 className="mt-4 font-serif text-3xl font-bold tracking-tight text-cream sm:text-4xl lg:text-5xl" data-testid="terms-title">
          Terms of Service
        </h1>
        <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.25em] text-cream/50">
          Aardvarks Vault · Texas, USA · Last updated July 2026
        </p>
        <nav className="mt-10 flex flex-wrap gap-2" aria-label="Terms sections">
          {sections.map((s) => (
            <a
              key={s.id}
              href={`#${s.id}`}
              data-testid={`terms-jump-${s.id}`}
              className="rounded-full border border-gold/25 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.15em] text-cream/60 transition-colors hover:border-gold hover:text-gold"
            >
              {s.title.split(". ")[1]}
            </a>
          ))}
        </nav>
        <div className="mt-12 space-y-10">
          {sections.map((s) => (
            <section key={s.id} id={s.id} className="scroll-mt-28 border-l-2 border-gold/25 pl-6" data-testid={`terms-section-${s.id}`}>
              <h2 className="font-serif text-xl font-semibold text-gold">{s.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-cream/75">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Terms;
